<template>
    <div class="loading el-icon-loading"></div>
</template>

<script>
import actions from '@/actions/index'
import * as utils from '@/utils/utils'

export default {
  data () {
    return {
      code: '', // 领英code
      account_type:'cv_account', // 账户种类 hr_account 或 cv_account
      isBindWechat: false, // 是否绑定微信
      isBindPhone: false // 是否绑定手机号
    }
  },
  created () {
    // 验证 领英 state
    let cookieLinkedInState = utils.getCookie('linkedInState')
    let urlLinkedInState = this.$route.query.state
    if (urlLinkedInState !== cookieLinkedInState) {
      this.$router.push('/signin_email')
      return false
    }
    // 验证 领英 code
    let code = this.$route.query.code
    if (!code) {
      this.$router.push('/signin_email')
      return false
    }
    this.getLinkedInUserInfo(code)
  },
  methods: {
    // 验证领英code,并返回用户信息
    getLinkedInUserInfo (code) {
      actions.auth.getLinkedInUserInfo({code: code}).then( async res => {
        if(res.code === 1000){
          let { wechat_is_bound, phone_is_bound, jwt, jwt_timestamp } = res.data
          this.$message({
            message: '登录成功，页面正在跳转…',
            type: 'success',
            duration: 2000
          });

          // 插入jwt 的登录状态
          try {
            await utils.updateJWT({
              jwt: jwt,
              jwt_timestamp: jwt_timestamp
            })
          } catch (error) {
            console.log(error)
          }

          this.isBindWechat = wechat_is_bound
          this.isBindPhone = phone_is_bound

          if(this.isBindPhone){
            localStorage.setItem('_n_b_p', false);
          }else{
            localStorage.setItem('_n_b_p', true);
          }

          if (!wechat_is_bound && !wechat_is_bound) {
            // 跳转到绑定手机页
            this.$router.push('/bind_phone')
          } else {
            //【登录成功】读取跳转页面
            this.pageJump(false)
          }
        } else {
          this.$message.error(res.message)
          this.$router.push('/signin_email')
        }
      })
    },
    // 登录成功 读取跳转页面
    pageJump(new_account){
      // if(new_account){
      //   //新用户跳转到cvs，然后自动会跳转到 选择身份页面
      //   window.location.href = window.location.origin+'/select_identity'
      // }else{
      let r_b_t = utils.getCookie('_r_b_t') || '';
      // 返回的url中必须有 wondercv
      if(!r_b_t.includes('wondercv')){
        r_b_t = '';
      }
      // 返回的url要进行解码再跳转
      if(r_b_t){
        r_b_t = decodeURIComponent(r_b_t);
      }
      let _t = utils.get_tUser();
      if(this.account_type==='hr_account'){
        if(!r_b_t.includes('/talent/')){
          r_b_t = '';
        }
        let hr_url = window.location.origin + `${this.isBindPhone? '/talent/userinfo':'/talent/binduser'}`
        let hr_indexUrl = window.location.origin + '/talent/search'
        //如果返回的url中包含 用户信息的url
        let link_to = r_b_t.includes(`${hr_url}`)? ( r_b_t.includes('?')?r_b_t+'&showJump=true':r_b_t+'?showJump=true' ) : `${hr_url}${r_b_t ? '?link_to='+encodeURIComponent(r_b_t)+'&showJump=true' : '?showJump=true'}`;
        // hr登录之后的判断, 是否是hr，判断是否绑定手机号 判断是否读取本地地址
        window.location.href = _t.h_t ? ( this.isBindPhone ? ( r_b_t || hr_indexUrl) : link_to ) : link_to ;
        utils.delCookie('_r_b_t');
      }else{
        // cv登录之后的判断
        if(r_b_t.includes('/talent/')){
          r_b_t = '';
        }
        // 不是新用户 && 有 r_b_t
        if(r_b_t && !new_account){
          window.location.href = r_b_t;
          utils.delCookie('_r_b_t');
        }else{
          //新用户跳转到cvs，然后自动会跳转到 选择身份页面
          window.location.href = window.location.origin+'/cvs'
        }
      }
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './Index.scss';
</style>
